/* unplugin-vue-components disabled */import script from "./Dahai.vue?vue&type=script&setup=true&lang=js"
export * from "./Dahai.vue?vue&type=script&setup=true&lang=js"

import "./Dahai.vue?vue&type=style&index=0&id=9bb826fe&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9bb826fe"]])

export default __exports__